(function (angular) {
  "use strict";

  // eslint-disable-next-line no-magic-numbers
  var DEFAULT_EXPIRY_HOURS = 24 * 365.25 * 10; // about 10 years

  /*
   * Wrapper to provide similar interface as the localstorage service
   *
   * It serialises object-valued cookies in Marketo style:
   *
   * - No opening and closing curly braces {}
   * - Fields are delimited by & instead of ,
   * - No double-quotes around keys nor values
   *
   * Example:
   * key1:value1&key2:value2&key3:value number three
   *
   * AngularJS then URI encodes the whole value before storing it in the cookie:
   * key1%3Avalue1%26key2%3Avalue2%26key3%3Avalue%20number%20three
   */

  angular.module("Toyota.Factories").factory("cookies", [
    "$cookies",
    function ($cookies) {
      var msPerHour = 3600000;

      return {
        set: function (key, value, expireHours, isRootPath) {
          var val = value;

          // Imitate Marketo cookie format
          if (typeof value === "object") {
            val = JSON.stringify(value)
              .replace(/^{/g, "")
              .replace(/}$/g, "")
              .replace(/","/g, '"&"')
              .replace(/"/g, "");
          }

          var options = {
            samesite: "strict",
          };

          /* eslint-disable no-param-reassign */
          if (!expireHours) {
            expireHours = DEFAULT_EXPIRY_HOURS;
          }
          /* eslint-enable no-param-reassign */

          var expires = new Date();
          expires.setTime(expires.getTime() + expireHours * msPerHour);
          options.expires = expires;

          if (isRootPath) {
            options.path = ".toyota.com.au";
          }

          $cookies.put(key, val, options);
        },
        get: function (key) {
          return $cookies.get(key);
        },
        exists: function (key) {
          return typeof $cookies.get(key) !== "undefined";
        },
        remove: function (key) {
          $cookies.remove(key);
        },
        removeWithDomain: function (key, domain) {
          // Delete cookie with name "key" for
          $cookies.remove(key, { path: "/", domain: domain });
        },
      };
    },
  ]);
})(window.angular);
